module.exports = __webpack_public_path__ + "img/746c1674fa1cbb09ea5dd707644457eb.png";